import { initGA } from './googleAnalytics';

export function initializeGoogleStatistics(selectedValues) {
  if (selectedValues.includes('Statistics')) {
    initGA();
  }
}
